import { render, staticRenderFns } from "./beckInterpretation.vue?vue&type=template&id=54e08206&scoped=true&"
import script from "./beckInterpretation.vue?vue&type=script&lang=js&"
export * from "./beckInterpretation.vue?vue&type=script&lang=js&"
import style0 from "./beckInterpretation.vue?vue&type=style&index=0&id=54e08206&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e08206",
  null
  
)

export default component.exports